<template>
  <div class="about section-vh">
    <b-container>
      <b-row>
        <b-col class="col my-5">
          <div class="text-left text-white" v-if="$i18n.locale === 'ru'">
            <div class="h5 text-left ufc-text-color border_title pb-4 mb-4">Система проведения соревнований – регулярные Head-2-Head Liga - турниры по спортивному симулятору UFC 6</div>
            <p>
              <b class="text-left ufc-text-color">Продолжительность турнира составляет не более одного дня.</b>
            </p>
            <p>
              Турнир состоит из 24 боев: круговая система (Quadruple Round Robin) в четыре круга. Бои не имеют дополнительного времени, в случае окончания боя по истечении времени, решение присуждается судьями.
            </p>
            <p>
              <b class="text-left ufc-text-color">Турнир проводится в один этап:</b><br>
            </p>
            <p>
              Групповой этап. Матчи группового этапа проводятся до решения судей.
            </p>
            <p>
              Все бойцы выступают в четыре круга между собой (у каждого бойца по 12 матчей), всего 24 боя в группе. Победитель выявляется на основании лучших показателей – набранных баллов.
            </p>
            <p>
              В ходе проведения группового этапа турнира бойцы набирают игровые баллы, которые по итогам каждого боя турнира складываются. Итоговое место бойца в групповом этапе определяется по сумме набранных очков. В зависимости от результата матча командам начисляются очки:
            </p>
            <ul>
              <li><b>3 балла</b> - Досрочная победа (KO, TKO, SUB)</li>
              <li><b>2 балла</b> - Победа решением судей</li>
              <li><b>1 балл</b> - Ничья/Поражение по решению судей</li>
              <li><b>0 баллов</b> - Досрочное поражение</li>
            </ul>
            <p>
              <b class="text-left ufc-text-color">В случае равенства количества баллов между 2 бойцами, победитель определяется согласно правилам, указанным ниже (по ранжированию):</b>
            </p>
            <ol>
              <li>Сумма баллов в личных встречах</li>
              <li>Досрочные победы в личных встречах</li>
              <li>Сумма времени, затраченная на победы в личных встречах</li>
              <li>Досрочные победы в турнире</li>
              <li>Сумма времени, затраченная на победы в турнире</li>
            </ol>
            <p>
              <b class="text-left ufc-text-color">В случае если одинаковое количество баллов было набрано тремя и более бойцами, победитель определяется согласно правилам, указанным ниже (по ранжированию):</b>
            </p>
            <ol>
              <li>Сумма баллов в личных встречах</li>
              <li>Досрочные победы в личных встречах</li>
              <li>Сумма времени, затраченная на победы в личных встречах</li>
              <li>Досрочные победы в турнире</li>
              <li>Сумма времени, затраченная на победы в турнире</li>
            </ol>
            <p>
              По окончании группового этапа производится подсчет баллов, по итогам которого выявляется победитель турнира.
            </p>
          </div>

          <div class="text-left text-white" v-else>
            <div class="h5 text-left ufc-text-color border_title pb-4 mb-4">Competition system: regular Head-2-Head League tournaments on UFC 5 sports simulator</div>
            <p>
              <b class="text-left ufc-text-color">The tournament lasts no longer than one day.</b>
            </p>
            <p>
              The tournament consists of 24 fights: Quadruple Round Robin system in four rounds. Fights do not have extra time - if the fight ends after time expires, the decision is awarded by the judges.
            </p>
            <p>
              <b class="text-left ufc-text-color">The tournament is held in one stage:</b><br>
            </p>
            <p>
              Group stage. Group stage matches are held until judges' decision.
            </p>
            <p>
              All fighters compete in four rounds against each other (each fighter has 12 matches), with a total of 24 fights in the group. The winner is determined based on the best performance - points scored.
            </p>
            <p>
              During the group stage of the tournament, fighters earn game points that are accumulated after each tournament fight. The final position of the fighter in the group stage is determined by the total points scored. Depending on the match result, points are awarded as follows:
            </p>
            <ul>
              <li><b>3 points</b> - Early victory (KO, TKO, SUB)</li>
              <li><b>2 points</b> - Victory by judges' decision</li>
              <li><b>1 point</b> - Draw/Loss by judges' decision</li>
              <li><b>0 points</b> - Early defeat</li>
            </ul>
            <p>
              <b class="text-left ufc-text-color">If two fighters are tied on points, the winner is determined according to the following tiebreaker rules (by ranking):</b>
            </p>
            <ol>
              <li>Total points in head-to-head matches</li>
              <li>Early victories in head-to-head matches</li>
              <li>Total time spent achieving victories in head-to-head matches</li>
              <li>Early victories in the tournament</li>
              <li>Total time spent achieving victories in the tournament</li>
            </ol>
            <p>
              <b class="text-left ufc-text-color">If three or more fighters are tied on points, the winner is determined according to the following tiebreaker rules (by ranking):</b>
            </p>
            <ol>
              <li>Total points in head-to-head matches</li>
              <li>Early victories in head-to-head matches</li>
              <li>Total time spent achieving victories in head-to-head matches</li>
              <li>Early victories in the tournament</li>
              <li>Total time spent achieving victories in the tournament</li>
            </ol>
            <p>
              At the end of the group stage, points are tallied and the tournament winner is determined.
            </p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "ufc_rules",
  data() {
    return {}
  },
  metaInfo () {
    return {
      title: this.$t('meta.sports.ufc.rules.title'),
      titleTemplate: 'H2H Liga | %s',
      meta: [
        {name: 'description', content: this.$t('meta.sports.ufc.rules.description')},
      ]
    }
  }
}
</script>

<style scoped>
.border_title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
</style>